import { DedupeComponent } from '../../dedupe/dedupe.component';
import { CustomersComponent } from './customers.component';
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/** Keeps the customer table mounted while a routed customer page opens in its place. */
@Component({
  selector: 'app-customer-workspace',
  templateUrl: './customer-workspace.component.html',
  host: { class: 'workspace-master-detail-page' },
})
export class CustomerWorkspaceComponent {
  @ViewChild(CustomersComponent) collection?: CustomersComponent;
  reviewClosed(component: unknown): void {
    if (component instanceof DedupeComponent && component.needsRefresh) this.collection?.onTransferChanged();
  }

  /**
   * Whether a routed detail page is open in place of the collection. Derived from
   * the route for the same reason the Leads workspace does it - see the note
   * there: an (activate) handler sets this too late in the change-detection
   * pass to be rendered, and the pane silently stays hidden.
   */
  get detailOpen(): boolean { return this.route.firstChild !== null; }

  constructor(private readonly route: ActivatedRoute) {}
}
